import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/reports/sub-pay-app-aging")({
  beforeLoad: () => {
    throw redirect({ to: "/reports/$reportId", params: { reportId: "3bded630-30e5-5751-8a11-27d0a3868bb6" }, replace: true });
  },
  component: () => null,
});
